export const IGNORED_ERROR_PATTERNS = [
  'failed to fetch',
  'networkerror',
  'load failed',
  'the user aborted a request',
  'the operation was aborted',
  'socket timed out',
  'timeout'
] as const;

export function shouldFilterError(e: unknown): boolean {
  const msg = String((e as any)?.message ?? e ?? '').toLowerCase();
  return IGNORED_ERROR_PATTERNS.some((p) => msg.includes(p));
}
